/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdrAnimalDto } from '../models/adr-animal-dto';
import { createAnimal } from '../fn/animal/create-animal';
import { CreateAnimal$Params } from '../fn/animal/create-animal';
import { getAnimal } from '../fn/animal/get-animal';
import { GetAnimal$Params } from '../fn/animal/get-animal';
import { inactivateAnimal } from '../fn/animal/inactivate-animal';
import { InactivateAnimal$Params } from '../fn/animal/inactivate-animal';
import { modifyCustomerAnimal } from '../fn/animal/modify-customer-animal';
import { ModifyCustomerAnimal$Params } from '../fn/animal/modify-customer-animal';
import { reactivateAnimal } from '../fn/animal/reactivate-animal';
import { ReactivateAnimal$Params } from '../fn/animal/reactivate-animal';

@Injectable({ providedIn: 'root' })
export class AnimalService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAnimal()` */
  static readonly GetAnimalPath = '/api/animals/{id}';

  /**
   * Returns an animal by the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAnimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimal$Response(params: GetAnimal$Params, context?: HttpContext): Observable<StrictHttpResponse<AdrAnimalDto>> {
    return getAnimal(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns an animal by the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAnimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimal(params: GetAnimal$Params, context?: HttpContext): Observable<AdrAnimalDto> {
    return this.getAnimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdrAnimalDto>): AdrAnimalDto => r.body)
    );
  }

  /** Path part for operation `modifyCustomerAnimal()` */
  static readonly ModifyCustomerAnimalPath = '/api/animals/{id}';

  /**
   * Update animal by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `modifyCustomerAnimal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyCustomerAnimal$Response(params: ModifyCustomerAnimal$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return modifyCustomerAnimal(this.http, this.rootUrl, params, context);
  }

  /**
   * Update animal by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `modifyCustomerAnimal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyCustomerAnimal(params: ModifyCustomerAnimal$Params, context?: HttpContext): Observable<void> {
    return this.modifyCustomerAnimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAnimal()` */
  static readonly CreateAnimalPath = '/api/animals/{id}';

  /**
   * Creates an animal with the given info
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAnimal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAnimal$Response(params: CreateAnimal$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAnimal(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates an animal with the given info
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAnimal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAnimal(params: CreateAnimal$Params, context?: HttpContext): Observable<void> {
    return this.createAnimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reactivateAnimal()` */
  static readonly ReactivateAnimalPath = '/api/animals/{id}/reactivate';

  /**
   * Reactivate an animal with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reactivateAnimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateAnimal$Response(params: ReactivateAnimal$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reactivateAnimal(this.http, this.rootUrl, params, context);
  }

  /**
   * Reactivate an animal with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reactivateAnimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateAnimal(params: ReactivateAnimal$Params, context?: HttpContext): Observable<void> {
    return this.reactivateAnimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `inactivateAnimal()` */
  static readonly InactivateAnimalPath = '/api/animals/{id}/inactivate';

  /**
   * Inactivate an animal with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inactivateAnimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateAnimal$Response(params: InactivateAnimal$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return inactivateAnimal(this.http, this.rootUrl, params, context);
  }

  /**
   * Inactivate an animal with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inactivateAnimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateAnimal(params: InactivateAnimal$Params, context?: HttpContext): Observable<void> {
    return this.inactivateAnimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
